<template>
  <aside class="menu">
    <div class="navbar-container-large" v-if="menuDesktopShow">
      <div class="content">
        <ul class="menu-list">
          <div class="dropdown link-cobalt">
            <input id="dr-1" type="checkbox"/>
            <label for="dr-1" class="col1_d">
              <icon-p-h-d/>
              <span>PHD Олег Мальцев</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd">
              <router-link class="dd-link" to="/activity">
                <li :class="{active: isSelected('/activity')}"><span>Научная деятельность</span></li>
              </router-link>
              <router-link class="dd-link" to="/activity-categories">
                <li :class="{active: isSelected('/activity-categories')}"><span>Категории</span></li>
              </router-link>
              <router-link class="dd-link" to="/quotes">
                <li :class="{active: isSelected('/quotes')}"><span>Цитаты</span></li>
              </router-link>
              <router-link class="dd-link" to="/diplomas">
                <li :class="{active: isSelected('/diplomas')}"><span>Дипломы и сертификаты</span></li>
              </router-link>
            </ul>
          </div>
          <div class="dropdown link-purple">
            <input id="dr-5" type="checkbox"/>
            <label for="dr-5" class="col2_d">
              <icon-group/>
              <span>Семинары и лекции</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd">
              <router-link class="dd-link" to="/seminars">
                <li :class="{active: isSelected('/seminars')}"><span>Семинары</span></li>
              </router-link>
              <router-link class="dd-link" to="/kruglyj-stol">
                <li :class="{active: isSelected('/kruglyj-stol')}"><span>Круглый стол</span></li>
              </router-link>
              <router-link class="dd-link" to="/seminars-categories">
                <li :class="{active: isSelected('/seminars-categories')}"><span>Категории семинаров</span></li>
              </router-link>
              <router-link class="dd-link" to="/lectures">
                <li :class="{active: isSelected('/lectures')}"><span>Лекции</span></li>
              </router-link>
              <router-link class="dd-link" to="/lectures-categories">
                <li :class="{active: isSelected('/lectures-categories')}"><span>Категории лекций</span></li>
              </router-link>
              <router-link class="dd-link" to="/photo-reports">
                <li :class="{active: isSelected('/photo-reports')}"><span>Фотоотчеты</span></li>
              </router-link>
              <router-link class="dd-link" to="/experts">
                <li :class="{active: isSelected('/experts')}"><span>Эксперты</span></li>
              </router-link>
            </ul>
          </div>
          <li class="col4 link-salad" :class="{active: isSelected('/courses')}">
            <router-link to="/courses">
              <icon-mortarboard/>
              <span>Короткие курсы</span></router-link>
          </li>
          <div class="dropdown link-yellow">
            <input id="dr-9" type="checkbox"/>
            <label for="dr-9" class="col1_d">
              <icon-library/>
              <span>Библиотека</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd">
              <router-link class="dd-link" to="/library/free">
                <li :class="{active: isSelected('/library/free')}"><span>Бесплатные книги</span></li>
              </router-link>
              <router-link class="dd-link" to="/library/paid">
                <li :class="{active: isSelected('/library/paid')}"><span>Платные книги</span></li>
              </router-link>
              <router-link class="dd-link" to="/library/audio">
                <li :class="{active: isSelected('/library/audio')}"><span>Аудиокниги</span></li>
              </router-link>
              <router-link class="dd-link" to="/library/films">
                <li :class="{active: isSelected('/library/films')}"><span>Фильмы</span></li>
              </router-link>
              <router-link class="dd-link" to="/library/films-categories">
                <li :class="{active: isSelected('/library/films-categories')}"><span>Категории фильмов</span></li>
              </router-link>
              <router-link class="dd-link" to="/library/recommended-films">
                <li :class="{active: isSelected('/library/recommended-films')}"><span>Рекомендуемые фильмы</span></li>
              </router-link>
              <router-link class="dd-link" to="/library/meters">
                <li :class="{active: isSelected('/library/meters')}"><span>Измерители</span></li>
              </router-link>
            </ul>
          </div>
          <div class="dropdown link-blue">
            <input id="dr-14" type="checkbox"/>
            <label for="dr-14" class="col1_d">
              <icon-blog/>
              <span>Блог</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd">
              <router-link class="dd-link" to="/blog">
                <li :class="{active: isSelected('/blog')}"><span>Статьи</span></li>
              </router-link>
              <router-link class="dd-link" to="/blog-categories">
                <li :class="{active: isSelected('/blog-categories')}"><span>Категории</span></li>
              </router-link>
            </ul>
          </div>
          <li class="col2 link-yellow-2" :class="{active: isSelected('/authors')}">
            <router-link to="/authors">
              <icon-pencil/>
              <span>Авторы</span></router-link>
          </li>
          <li class="col3 link-grey" :class="{active: isSelected('/albums')}">
            <router-link to="/albums">
              <icon-albums/>
              <span>Альбомы</span></router-link>
          </li>
          <li class="col2 link-green" :class="{active: isSelected('/pages')}">
            <router-link to="/pages">
              <icon-file/>
              <span>Страницы</span></router-link>
          </li>
          <div class="dropdown link-cobalt">
            <input id="dr-11" type="checkbox"/>
            <label for="dr-11" class="col5_d">
              <icon-reviews/>
              <span>Отзывы</span>
              <span v-if="totalNewReviews" class="unread">{{totalNewReviews}}</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd">
              <router-link class="dd-link" to="/reviews">
                <li :class="{active: isSelected('/reviews')}"><span>Отзывы</span><span v-if="newReviews.common" class="unread">{{newReviews.common}}</span></li>
              </router-link>
              <router-link class="dd-link" to="/reviews/scientist">
                <li :class="{active: isSelected('/reviews/scientist')}"><span>Отзывы Олег Мальцев</span><span v-if="newReviews.malcev" class="unread">{{newReviews.malcev}}</span></li>
              </router-link>
              <router-link class="dd-link" to="/reviews/publications">
                <li :class="{active: isSelected('/reviews/publications')}"><span>Отзывы в публикациях</span><span v-if="newReviews.articles" class="unread">{{newReviews.articles}}</span></li>
              </router-link>
            </ul>
          </div>
          <div class="dropdown link-purple">
            <input id="dr-13" type="checkbox"/>
            <label for="dr-13" class="col5_d">
              <icon-house/>
              <span>Главная страница</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd">
              <router-link class="dd-link" to="/description-pages">
                <li :class="{active: isSelected('/description-pages')}"><span>Описание страниц</span></li>
              </router-link>
              <router-link class="dd-link" to="/partners">
                <li :class="{active: isSelected('/partners')}"><span>Партнеры</span></li>
              </router-link>
            </ul>
          </div>
          <li class="col4 link-salad" :class="{active: isSelected('/contacts')}">
            <router-link to="/contacts">
              <icon-contacts/>
              <span>Контакты</span></router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="navbar-container-little" v-else>
      <ul class="menu-list">
        <li class="col5 link-cobalt">
          <span class="a">
          <icon-p-h-d/>
          <span class="hint_lg">
          <span class="caption">PHD Олег Мальцев</span>
          <ul>
            <li :class="{active: isSelected('/activity')}"><router-link
              to="/activity"><span>Научная деятельность</span></router-link></li>
            <li :class="{active: isSelected('/activity-categories')}"><router-link
              to="/activity-categories"><span>Категории</span></router-link></li>
            <li :class="{active: isSelected('/quotes')}"><router-link
              to="/quotes"><span>Цитаты</span></router-link></li>
            <li :class="{active: isSelected('/diplomas')}"><router-link
              to="/diplomas"><span>Дипломы и сертификаты</span></router-link></li>
          </ul>
          </span>
          </span>
        </li>
        <li class="col6 link-purple">
          <span class="a">
          <icon-group/>
          <span class="hint_lg">
          <span class="caption">Семинары и лекции</span>
          <ul>
            <li :class="{active: isSelected('/seminars')}"><router-link
              to="/seminars"><span>Семинары</span></router-link></li>
            <li :class="{active: isSelected('/kruglyj-stol')}"><router-link
              to="/kruglyj-stol"><span>Круглый стол</span></router-link></li>
            <li :class="{active: isSelected('/seminars-categories')}"><router-link
              to="/seminars-categories"><span>Категории семинаров</span></router-link></li>
            <li :class="{active: isSelected('/lectures')}"><router-link
              to="/lectures"><span>Лекции</span></router-link></li>
            <li :class="{active: isSelected('/lectures-categories')}"><router-link
              to="/lectures-categories"><span>Категории лекций</span></router-link></li>
            <li :class="{active: isSelected('/photo-reports')}"><router-link
              to="/photo-reports"><span>Фотоотчеты</span></router-link></li>
            <li :class="{active: isSelected('/experts')}"><router-link
              to="/experts"><span>Эксперты</span></router-link></li>
          </ul>
          </span>
          </span>
        </li>
        <li class="col1 link-salad" :class="{active: isSelected('/courses')}">
          <router-link to="/courses">
            <icon-mortarboard/>
            <span class="hint">Короткие курсы</span></router-link>
        </li>
        <li class="col1 link-yellow">
          <span class="a">
          <icon-library/>
          <span class="hint_lg">
          <span class="caption">Библиотека</span>
          <ul>
            <li :class="{active: isSelected('/library/free')}"><router-link
                    to="/library/free"><span>Бесплатные книги</span></router-link></li>
            <li :class="{active: isSelected('/library/paid')}"><router-link
                    to="/library/paid"><span>Платные книги</span></router-link></li>
            <li :class="{active: isSelected('/library/audio')}"><router-link
                    to="/library/audio"><span>Аудиокниги</span></router-link></li>
            <li :class="{active: isSelected('/library/films')}"><router-link
                    to="/library/films"><span>Фильмы</span></router-link></li>
            <li :class="{active: isSelected('/library/films-categories')}"><router-link
              to="/library/films-categories"><span>Категории фильмов</span></router-link></li>
            <li :class="{active: isSelected('/library/recommended-films')}"><router-link
                    to="/library/recommended-films"><span>Рекомендуемые фильмы</span></router-link></li>
            <li :class="{active: isSelected('/library/meters')}"><router-link
                    to="/library/meters"><span>Измерители</span></router-link></li>
          </ul>
          </span>
          </span>
        </li>
        <li class="col1 link-blue">
          <span class="a">
          <icon-blog/>
          <span class="hint_lg">
          <span class="caption">Блог</span>
          <ul>
            <li :class="{active: isSelected('/blog')}"><router-link
              to="/blog"><span>Статьи</span></router-link></li>
            <li :class="{active: isSelected('/blog-categories')}"><router-link
              to="/blog-categories"><span>Категории</span></router-link></li>
          </ul>
          </span>
          </span>
        </li>
        <li class="col2 link-yellow-2" :class="{active: isSelected('/authors')}">
          <router-link to="/authors">
            <icon-pencil/>
            <span class="hint">Авторы</span></router-link>
        </li>
        <li class="col3 link-grey" :class="{active: isSelected('/albums')}">
          <router-link to="/albums">
            <icon-albums/>
            <span class="hint">Альбомы</span></router-link>
        </li>
        <li class="col2 link-green" :class="{active: isSelected('/pages')}">
          <router-link to="/pages">
            <icon-file/>
            <span class="hint">Страницы</span></router-link>
        </li>
        <li class="col5 link-cobalt">
          <span class="a">
          <span v-if="totalNewReviews" class="unread">{{totalNewReviews}}</span>
          <icon-reviews/>
          <span class="hint_lg">
          <span class="caption">Отзывы</span>
          <ul>
            <li :class="{active: isSelected('/reviews')}"><router-link
              to="/activity"><span>Отзывы</span><span v-if="newReviews.common" class="unread">{{newReviews.common}}</span></router-link></li>
            <li :class="{active: isSelected('/reviews/scientist')}"><router-link
              to="/reviews/scientist"><span>Отзывы Олег Мальцев</span><span v-if="newReviews.malcev" class="unread">{{newReviews.malcev}}</span></router-link></li>
            <li :class="{active: isSelected('/reviews/publications')}"><router-link
              to="/reviews/publications"><span>Отзывы в публикациях</span><span v-if="newReviews.articles" class="unread">{{newReviews.articles}}</span></router-link></li>
          </ul>
          </span>
          </span>
        </li>
        <li class="col5 link-purple">
          <span class="a">
          <icon-house/>
          <span class="hint_lg">
          <span class="caption">Главная страница</span>
          <ul>
            <li :class="{active: isSelected('/description-pages')}"><router-link
              to="/description-pages"><span>Описание страниц</span></router-link></li>
            <li :class="{active: isSelected('/partners')}"><router-link
              to="/partners"><span>Партнеры</span></router-link></li>
          </ul>
          </span>
          </span>
        </li>
        <li class="col1 link-salad" :class="{active: isSelected('/contacts')}">
          <router-link to="/contacts">
            <icon-contacts/>
            <span class="hint">Контакты</span></router-link>
        </li>
      </ul>
    </div>
    <transition name="fade">
      <div @click="$store.dispatch('showMenu', { menuType: 'mobile', flag: false })" v-if="menuMobileShow"
           class="menu-mobile-bg"></div>
    </transition>
    <div :class="{ 'open' : menuMobileShow }"
         class="navbar-container-large menu-mobile">
      <div class="content">
        <ul class="menu-list">
          <div class="dropdown link-cobalt">
            <input id="dr-2" type="checkbox"/>
            <label for="dr-2" class="col5_d">
              <icon-p-h-d/>
              <span>PHD Олег Мальцев</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd-mobile">
              <router-link to="/activity">
                <li class="dd-link" :class="{active: isSelected('/activity')}"><span>Научная деятельность</span></li>
              </router-link>
              <router-link to="/activity-categories">
                <li class="dd-link" :class="{active: isSelected('/activity-categories')}"><span>Категории</span></li>
              </router-link>
              <router-link to="/quotes">
                <li class="dd-link" :class="{active: isSelected('/quotes')}"><span>Цитаты</span></li>
              </router-link>
              <router-link to="/diplomas">
                <li class="dd-link" :class="{active: isSelected('/diplomas')}"><span>Дипломы и сертификаты</span></li>
              </router-link>
            </ul>
          </div>
          <div class="dropdown link-purple">
            <input id="dr-4" type="checkbox"/>
            <label for="dr-4" class="col6_d">
              <icon-group/>
              <span>Семинары и лекции</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd-mobile">
              <router-link to="/seminars">
                <li class="dd-link" :class="{active: isSelected('/seminars')}"><span>Семинары</span></li>
              </router-link>
              <router-link to="/kruglyj-stol">
                <li class="dd-link" :class="{active: isSelected('/kruglyj-stol')}"><span>Круглый стол</span></li>
              </router-link>
              <router-link to="/seminars-categories">
                <li class="dd-link" :class="{active: isSelected('/seminars-categories')}"><span>Категории семинаров</span></li>
              </router-link>
              <router-link to="/lectures">
                <li class="dd-link" :class="{active: isSelected('/lectures')}"><span>Лекции</span></li>
              </router-link>
              <router-link to="/lectures-categories">
                <li class="dd-link" :class="{active: isSelected('/lectures-categories')}"><span>Категории лекций</span></li>
              </router-link>
              <router-link to="/photo-reports">
                <li class="dd-link" :class="{active: isSelected('/photo-reports')}"><span>Фотоотчеты</span></li>
              </router-link>
              <router-link to="/experts">
                <li class="dd-link" :class="{active: isSelected('/experts')}"><span>Эксперты</span></li>
              </router-link>
            </ul>
          </div>
          <li class="col1 link-salad" :class="{active: isSelected('/courses')}">
            <router-link to="/courses">
              <icon-mortarboard/>
              <span>Короткие курсы</span></router-link>
          </li>
          <div class="dropdown link-yellow">
            <input id="dr-8" type="checkbox"/>
            <label for="dr-8" class="col1_d">
              <icon-library/>
              <span>Библиотека</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd-mobile">
              <router-link to="/library/free">
                <li class="dd-link" :class="{active: isSelected('/library/free')}"><span>Бесплатные книги</span></li>
              </router-link>
              <router-link to="/library/paid">
                <li class="dd-link" :class="{active: isSelected('/library/paid')}"><span>Платные книги</span></li>
              </router-link>
              <router-link to="/library/audio">
                <li class="dd-link" :class="{active: isSelected('/library/audio')}"><span>Аудиокниги</span></li>
              </router-link>
              <router-link to="/library/films">
                <li class="dd-link" :class="{active: isSelected('/library/films')}"><span>Фильмы</span></li>
              </router-link>
              <router-link to="/library/films-categories">
                <li class="dd-link" :class="{active: isSelected('/library/films-categories')}"><span>Категории фильмов</span></li>
              </router-link>
              <router-link to="/library/recommended-films">
                <li class="dd-link" :class="{active: isSelected('/library/recommended-films')}"><span>Рекомендуемые фильмы</span></li>
              </router-link>
              <router-link to="/meters">
                <li class="dd-link" :class="{active: isSelected('/meters')}"><span>Измерители</span></li>
              </router-link>
            </ul>
          </div>
          <div class="dropdown link-blue">
            <input id="dr-16" type="checkbox"/>
            <label for="dr-16" class="col1_d">
              <icon-blog/>
              <span>Блог</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd-mobile">
              <router-link to="/blog">
                <li class="dd-link" :class="{active: isSelected('/blog')}"><span>Статьи</span></li>
              </router-link>
              <router-link to="/blog-categories">
                <li class="dd-link" :class="{active: isSelected('/blog-categories')}"><span>Категории</span></li>
              </router-link>
            </ul>
          </div>
          <li class="col2 link-yellow-2" :class="{active: isSelected('/authors')}">
            <router-link to="/authors">
              <icon-pencil/>
              <span>Авторы</span></router-link>
          </li>
          <li class="col3 link-grey" :class="{active: isSelected('/albums')}">
            <router-link to="/albums">
              <icon-albums/>
              <span>Альбомы</span></router-link>
          </li>
          <li class="col2 link-green" :class="{active: isSelected('/pages')}">
            <router-link to="/pages">
              <icon-file/>
              <span>Страницы</span></router-link>
          </li>
          <div class="dropdown link-cobalt">
            <input id="dr-12" type="checkbox"/>
            <label for="dr-12" class="col5_d">
              <icon-reviews/>
              <span>Отзывы</span>
              <span class="triangle"></span>
              <span v-if="totalNewReviews" class="unread">{{totalNewReviews}}</span>
            </label>
            <ul class="menu-dd-mobile">
              <router-link to="/reviews">
                <li class="dd-link" :class="{active: isSelected('/reviews')}"><span>Отзывы</span><span v-if="newReviews.common" class="unread">{{newReviews.common}}</span></li>
              </router-link>
              <router-link to="/reviews/scientist">
                <li class="dd-link" :class="{active: isSelected('/reviews/scientist')}"><span>Отзывы Олег Мальцев</span><span v-if="newReviews.malcev" class="unread">{{newReviews.malcev}}</span></li>
              </router-link>
              <router-link to="/reviews/publications">
                <li class="dd-link" :class="{active: isSelected('/reviews/publications')}"><span>Отзывы в публикациях</span><span v-if="newReviews.articles" class="unread">{{newReviews.articles}}</span></li>
              </router-link>
            </ul>
          </div>
          <div class="dropdown link-purple">
            <input id="dr-15" type="checkbox"/>
            <label for="dr-15" class="col5_d">
              <icon-house/>
              <span>Главная страница</span>
              <span class="triangle"></span>
            </label>
            <ul class="menu-dd-mobile">
              <router-link to="/description-pages">
                <li class="dd-link" :class="{active: isSelected('/description-pages')}"><span>Описание страниц</span></li>
              </router-link>
              <router-link to="/partners">
                <li class="dd-link" :class="{active: isSelected('/partners')}"><span>Партнеры</span></li>
              </router-link>
            </ul>
          </div>
          <li class="col1 link-salad" :class="{active: isSelected('/contacts')}">
            <router-link to="/contacts">
              <icon-contacts/>
              <span>Контакты</span></router-link>
          </li>
        </ul>
      </div>
    </div>
    <div :class="{'small' : !menuDesktopShow }" class="for_button">
      <button @click="$store.dispatch('toggleMenu', { menuType: 'desktop' })">
        <icon-arrowleft/>
      </button>
    </div>
  </aside>
</template>

<script>
  import IconTv from './icons/IconTv.vue'
  import IconServices from './icons/IconServices.vue'
  import IconFile from './icons/IconFile.vue'
  import IconPortfolio from './icons/IconPortfolio.vue'
  import IconBlog from './icons/IconBlog.vue'
  import IconUser from './icons/IconUser.vue'
  import IconShield from './icons/IconShield.vue'
  import IconBrowse from './icons/IconBrowse.vue'
  import IconArrowleft from './icons/IconArrowleft.vue'
  import IconTablegrid from './icons/IconTablegrid.vue'
  import IconVacancies from './icons/IconVacancies.vue'
  import IconAnkets from './icons/IconAnkets.vue'
  import IconContacts from './icons/IconContacts.vue'
  import IconPeople from './icons/IconPeople.vue'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import IconAlbums from "./icons/IconAlbums";
  import IconReviews from "./icons/IconReviews";
  import IconSeminars from "./icons/IconSeminars";
  import IconLectures from './icons/IconLectures'
  import IconOnline from './icons/IconOnline'
  import IconLibrary from './icons/IconLibrary'
  import IconAi from './icons/IconAi'
  import IconPencil from '@/components/icons/IconPencil'
  import IconPHD from '@/components/icons/IconPHD'
  import IconMortarboard from '@/components/icons/IconMortarboard'
  import IconGroup from '@/components/icons/IconGroup'
  import IconHouse from '@/components/icons/IconHouse'

  export default {
    data() {
      return {
        showLargeMenu: false
      }
    },
    methods: {
      onShowLargeMenu() {
        this.showLargeMenu = true
        this.$store.commit('setIsHiddenMenu', false)
      },
      hideLargeMenu() {
        this.showLargeMenu = false
        this.$store.commit('setIsHiddenMenu', true)
      },
      toggleLargeMenu() {
        if (this.showLargeMenu == true) {
          this.showLargeMenu = false;
          this.$store.commit('setIsHiddenMenu', true)
        } else {
          this.showLargeMenu = true;
          this.$store.commit('setIsHiddenMenu', false)
        }
      },
      ...mapActions([
        'showMenu',
        'toggleMenu',
        'getNewReviews'
      ]),
      isSelected(url) {
        return this.$route.path === url
      }
    },
    created() {
      this.$store.dispatch('checkMenuStateOnLoad')
      this.getNewReviews()
    },
    mounted() {
      setInterval(() => {
        this.getNewReviews()
      }, 180000)
    },
    computed: {
      ...mapState([
        'menuMobileShow',
        'menuDesktopShow',
      ]),
      newReviews() {
        return this.$store.state.newReviews
      },
      totalNewReviews() {
        return this.newReviews.common + this.newReviews.malcev + this.newReviews.articles
      }
    },
    components: {
      IconAi,
      IconLibrary,
      IconOnline,
      IconLectures,
      IconSeminars,
      IconReviews,
      IconAlbums,
      IconTv,
      IconUser,
      IconShield,
      IconBrowse,
      IconTablegrid,
      IconArrowleft,
      IconServices,
      IconPortfolio,
      IconFile,
      IconBlog,
      IconAnkets,
      IconVacancies,
      IconContacts,
      IconPeople,
      IconPencil,
      IconPHD,
      IconMortarboard,
      IconHouse,
      IconGroup
    },
    watch: {
      $route(to, from) {
        this.$store.dispatch('showMenu', {
          menuType: 'mobile',
          flag: false
        });
      }
    }
  }
</script>

<style lang="scss">
  $white: #fff;
  $main-bg-color: #f1f2f7;
  $white-3: #e4e8eb;
  $white-2: #f8f9fb;
  $grey-4: #d8d9d9;

  $grey-5: #55575c;
  $grey-3: #999a9d;
  $grey-6: #6e7074;
  $grey-2: #46484c;

  $blue: #089cd3;

  $pink: #f27777;

  $green-2: #376d27;

  $grey-7: rgba(70, 72, 77, .9);
  $grey-1: #46484c;

  #app .dropdown label ~ ul.menu-dd-mobile a li.dd-link {
    padding-left: 9px;
    padding-top: 8px;
  }

  .fade-enter-active {
    transition: opacity 1s;
  }

  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .menu-mobile-bg {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .3);
    z-index: 2;
  }

  .menu .navbar-container-large.menu-mobile {
    position: fixed;
    top: 60px;
    left: 0;
    height: calc(100vh - 60px);
    transform: translateX(-100%);
    transition: transform .4s ease;
    z-index: 3;

    &.open {
      transform: translateX(0);
    }
  }

  .navbar-container-large:not(.menu-mobile),
  .navbar-container-little {
    @media screen and (max-width: 1023px) {
      display: none;
    }
  }

  .menu {
    position: fixed;
    top: 60px;
    z-index: 2;

    .navbar-container-little {
      min-height: calc(100vh - 60px);
      width: 53px;
      border-right: 1px solid $white-3;
      background: $white;
      position: relative;
      transition: width .4s ease;

      .menu-list {
        padding-top: 24px;
        padding-left: 0;
        list-style: none;

        li {
          margin: 7px 0;
          position: relative;
          padding: 4px 0;
          width: 60px;

          &:last-child {
            .a:hover {
              padding-bottom: 140px;
            }
          }

          &:first-child {
            margin-top: 0;
          }

          a, .a {
            cursor: pointer;
            padding: 5px 18px;
            display: flex;
            width: 58px;

            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              height: 80%;
              transform: translateY(-50%);
              width: 7px;
              border-radius: 0 7px 7px 0;
              transition: .3s;
            }

            .unread {
              width: 20px;
              height: 20px;
              background-color: #f27777;
              border-radius: 50%;
              position: absolute;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 9px;
              font-weight: 400;
              border: 2px solid white;
              top: 3px;
              right: 15px;
            }

            .hint {
              top: 8px;
              left: calc(100% - 2px);
              transform: translate(0, -100%);

              &:before {
                left: -5px;
                top: 50%;
                transform: rotate(-180deg) translateY(50%);
                border-color: transparent transparent transparent rgba(70, 72, 77, 0.9);
              }
            }

            .hint_lg {
              position: absolute;
              color: $white;
              background: $white;
              border-radius: 7px;
              opacity: 0;
              transform: scale(.7);
              transition: .3s;
              pointer-events: none;

              top: 3px;
              left: calc(100% - 8px);
              font-size: 15px;
              z-index: 101;
              min-width: 200px;
              color: $grey-2;
              box-shadow: 3px 7px 40px rgba(0, 0, 0, 0.14);

              &:before {
                content: '';
                position: absolute;
                border-left: 6px solid $white-2;
                border-top: 5px solid transparent;
                border-bottom: 5px solid transparent;
                left: -5px;
                top: 15px;
                transform: rotate(-180deg);
              }

              .caption {
                border-bottom: 1px solid #e7ebed;
                background: $white-2;
                font-weight: 500;
                display: block;
                padding: 14px 20px;
                position: relative;
                border-radius: 7px 7px 0 0;
                font-size: 15px !important;

                &:before {
                  content: '';
                  position: absolute;
                  bottom: 100%;
                  left: 50%;
                  margin-left: -5px;
                  border-width: 5px;
                  border-style: solid;
                  left: -5px;
                  top: 50%;
                  transform: rotate(-180deg) translateY(50%);
                  border-color: transparent transparent transparent $white-2;
                }
              }

              ul {
                padding: 12px 20px 18px 38px;
                list-style-type: disc;
                color: $blue;

                li {
                  padding: 4px 0 0;
                  margin: 0;
                  width: auto;

                  .unread {
                    width: 20px;
                    height: 20px;
                    background-color: #f27777;
                    border-radius: 50%;
                    color: white !important;
                    display: flex;
                    position: static;
                    align-items: center;
                    justify-content: center;
                    font-size: 9px;
                    font-weight: 400;
                    flex-shrink: 0;
                    border: 2px solid white;
                  }

                  a {
                    padding: 8px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    &:after {
                      display: none;
                    }
                  }

                  span {
                    color: $grey-6;
                  }

                  &:hover span {
                    color: $blue;
                  }

                  &.active {
                    font-weight: 600;

                    a span {
                      color: $green-2;
                    }
                  }
                }
              }
            }

            &:hover .hint_lg {
              transform: scale(1);
              opacity: 1;
              pointer-events: all;
            }

            &:hover .hint {
              transition-delay: .3s;
              transform: translate(0, -25%);
              opacity: 1;
            }
          }
        }

      }

      button {
        position: absolute;
        bottom: 13px;
        left: 13px;
        width: 25px;
        height: 25px;
        background: #7c7e82;
        border-radius: 3px;
        border: none;
        transition: .2s;
        transform: rotate(180deg);

        & svg {
          color: $white;
          margin-top: 3px;
        }

        &:hover {
          background: $blue;
        }
      }
    }

    .navbar-container-large {
      padding-bottom: 15px;
      height: calc(100vh - 116px);
      width: 240px;
      border-right: 1px solid $white-3;
      background: $white;
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      transition: width .4s ease;

      .content {
        flex: 1 0 auto;
      }

      .tittle {
        padding: 30px 0 11px 20px;
        color: $grey-3;
        text-transform: uppercase;
      }

      .margin14px {
        height: 14px;
        border-bottom: 1px solid $white-3;
        margin: 0 10px;
      }

      .menu-list {
        list-style: none;
        padding-left: 0;
        padding-top: 20px;

        .dropdown label.col5_d ~ .menu-dd li::before {
          background-color: #65d3da
        }

        .dropdown input {
          &:checked ~ label.col5_d::after {
            background-color: #65d3da
          }

          & ~ label.col5_d {
            svg {
              color: #65d3da;
            }

            &:hover::after {
              background-color: #65d3da;
            }
          }

          & ~ ul.menu-dd {
            padding-left: 41px;

            & li::before {
              left: -36px;
            }

            a.dd-link {
              padding: 7px 20px 7px 15px;
            }
          }
        }

        li {
          position: relative;
          padding: 4px 0;

          &:last-child {
            padding: 4px 0 2px;
          }

          a {
            padding: 7px 20px 7px 22px;
            display: flex;
            position: relative;

            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              height: 80%;
              transform: translateY(-50%);
              width: 7px;
              border-radius: 0 7px 7px 0;
              transition: .3s;
            }

            .unread {
              margin-left: auto;
              height: 18px;
              padding: 1px 10px 0;;
              background-color: #f27777;
              color: white !important;
              font-size: 11px;
              font-weight: 400 !important;
              border-radius: 5px;
              display: flex;
              align-items: center;
            }

            span {
              color: $grey-6;
              transition: .2s;
              margin-left: 20px;
              font-size: 15px;
            }

            svg {
              height: 19px;
            }

            &:hover span {
              color: $blue;
            }
          }
        }

        .active {
          a {
            span {
              color: $green-2;
              font-weight: 600;
            }

            &:hover span {
              color: $green-2;
            }
          }
        }
      }

      .dropdown {
        position: relative;
        padding: 5px 0 4px;

        label {
          padding: 7px 30px 7px 22px;
          display: flex;

          &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            width: 7px;
            height: 80%;
            transform: translateY(-50%);
            border-radius: 0 7px 7px 0;
            background: transparent;
            transition: .3s;
          }

          &:hover {
            span {
              color: $blue;
            }

            .triangle {
              color: $blue;
            }
          }

          span {
            margin-left: 20px;
            color: $grey-6;
            transition: .3s;
            font-size: 15px;
            max-width: 120px;
            &.unread {
              margin-left: auto;
              margin-right: 10px;
              height: 18px;
              padding: 1px 8px 0;;
              background-color: #f27777;
              color: white !important;
              font-size: 11px;
              font-weight: 400 !important;
              border-radius: 5px;
              display: flex;
              align-items: center;
            }
          }

          .triangle {
            position: absolute;
            right: 22px;
            transition: .3s;
          }

          &.col7_d {
            &:hover:after {
              background: #65daa2;
            }

            & svg {
              color: #65daa2;
            }

            & ~ ul li::before {
              background-color: #65daa2;
            }
          }
          &.col6_d {
            &:hover:after {
              background: #f27777;
            }

            & svg {
              color: #f27777;
            }

            & ~ ul li::before {
              background-color: #f27777;
            }
          }
          &.col1_d {
            &:hover:after {
              background: #089cd3;
            }

            & svg {
              color: #089cd3;
            }

            & ~ ul li::before {
              background-color: #089cd3;
            }
          }
        }

        input:checked + .сolumns:after {
          background: #65daa2;
        }

        input:checked + .col1_d:after {
          background: #089cd3;
        }

        input:checked + .col7_d:after {
          background: #65daa2;
        }
        input:checked + .col6_d:after {
          background: #f27777;
        }

        input:checked + label:after {
          height: calc(100% - 11px);
        }

        ul {
          overflow: hidden;
          max-height: 0px;
          position: relative;
          background: transparent;
          list-style-type: none;
          box-shadow: none;
          padding-left: 40px;
          transition: max-height .3s;

          li {
            font-size: 22px;
            line-height: 22px;
            color: $blue;
            display: flex;
            align-items: center;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              width: 7px;
              height: 7px;
              left: -20px;
              top: calc(50% - 2px);
              border-radius: 50%;
            }

            span {
              font-size: 15px;
              color: $grey-6;
              white-space: initial;
              &.unread {
                margin-left: auto;
                height: 18px;
                padding: 1px 8px 0;;
                background-color: #f27777;
                color: white !important;
                font-size: 11px;
                font-weight: 400 !important;
                border-radius: 5px;
                display: flex;
                align-items: center;
              }
            }

            &:hover span {
              color: $blue;
            }

            &.active span {
              color: $green-2;
            }
          }
        }

        input:checked ~ ul {
          max-height: 3000px;
          padding: 1px 0 0 47px;
          transition: max-height .3s;
        }

        input:not(:checked) ~ ul {
          padding: 0;
        }
      }
    }
  }

  @keyframes hint-lg {
    0% {
      opacity: 0;
      transform: scale(.7);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .for_button {
    width: 100%;
    height: 56px;
    text-align: right;
    position: fixed;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid $white-3;
    border-right: 1px solid $white-3;
    left: 0;
    bottom: 0;
    max-width: 240px;
    background-color: $white;
    transition: max-width .4s ease;

    @media screen and (max-width: 1023px) {
      display: none;
    }
    z-index: 1;

    button {
      width: 25px;
      height: 25px;
      background: #7c7e82;
      border-radius: 3px;
      border: none;
      transition: .2s;
      flex: 0 0 auto;
      margin-right: 13px;
      transition: transform .4s ease;

      & svg {
        color: $white;
        display: block;
        margin: 0 auto;
        margin-bottom: 1px;
      }

      &:hover {
        background: $blue;
      }
    }

    &.small {
      max-width: 53px;

      button {
        transform: rotate(180deg);

        svg {
          margin-bottom: 0;
        }
      }
    }
  }

  .navbar-container-large .menu-list {
    margin-bottom: 2px;
  }

  .col1 {
    a, .a, a.router-link-active {
      color: #089cd3;

      &:hover:after {
        background: #089cd3;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #089cd3;
    }

    .hint_lg ul li {
      color: #089cd3;
    }
  }

  .col2 {
    a, .a, a.router-link-active {
      color: #ab6fef;

      &:hover:after {
        background: #ab6fef;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #ab6fef;
    }
  }

  .col3 {
    a, .a, a.router-link-active {
      color: #61cc40;

      &:hover:after {
        background: #61cc40;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #61cc40;
    }
  }

  .col4 {
    a, .a, a.router-link-active {
      color: #fe8b4c;

      &:hover:after {
        background: #fe8b4c;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #fe8b4c;
    }
  }

  .col5 {
    a, .a, a.router-link-active {
      color: #65d3da;

      &:hover:after {
        background: #65d3da;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #65d3da;
    }
  }

  .col6 {
    a, .a, a.router-link-active {
      color: #f27777;

      &:hover:after {
        background: #f27777;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #f27777;
    }
  }

  .col7 {
    a, .a, a.router-link-active {
      color: #9591c2;

      &:hover:after {
        background: #9591c2;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #9591c2;
    }
  }

  .col8 {
    a, .a, a.router-link-active {
      color: #65daa2;

      &:hover:after {
        background: #65daa2;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #65daa2;
    }

    .hint_lg ul li {
      color: #65daa2;
    }
  }

  .col9 {
    a, .a, a.router-link-active {
      color: #fe8b4c;

      &:hover:after {
        background: #fe8b4c;
      }
    }

    &.active a:after, .router-link-active:after {
      background: #fe8b4c;
    }
  }

  .navbar-container-large::-webkit-scrollbar {
    width: 4px;
    background-color: #e2e2e4;
  }

  .navbar-container-large::-webkit-scrollbar-thumb {
    background: $grey-1;
  }

  @media screen and (max-height: 550px) {
    .menu .navbar-container-little button {
      position: static;
      margin: 20px 0 14px 14px;
    }
  }

  .link-cobalt {
    svg {
      color: $blue !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: $blue !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: $blue !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: $blue !important;
      }
    }

    .router-link-active::after {
      background: $blue !important;
    }
  }
  .link-purple {
    svg {
      color: #ab6fef !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #ab6fef !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #ab6fef !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #ab6fef !important;
      }
    }

    .router-link-active::after {
      background: #ab6fef !important;
    }
  }
  .link-salad {
    svg {
      color: #61cc40 !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #61cc40 !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #61cc40 !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #61cc40 !important;
      }
    }

    .router-link-active::after {
      background: #61cc40 !important;
    }
  }
  .link-yellow {
    svg {
      color: #fe8b4c !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #fe8b4c !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #fe8b4c !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #fe8b4c !important;
      }
    }

    .router-link-active::after {
      background: #fe8b4c !important;
    }
  }
  .link-blue {
    svg {
      color: #65d3da !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #65d3da !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #65d3da !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #65d3da !important;
      }
    }

    .router-link-active::after {
      background: #65d3da !important;
    }
  }
  .link-yellow-2 {
    svg {
      color: #f27777 !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #f27777 !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #f27777 !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #f27777 !important;
      }
    }

    .router-link-active::after {
      background: #f27777 !important;
    }
  }
  .link-grey {
    svg {
      color: #9591c2 !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #9591c2 !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #9591c2 !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #9591c2 !important;
      }
    }

    .router-link-active::after {
      background: #9591c2 !important;
    }
  }
  .link-green {
    svg {
      color: #65daa2 !important;
    }
    a.active::after, input:checked ~ label:after, .menu-dd li:before, &.active a:after, .dd-link::before {
      background: #65daa2 !important;
    }
    .hint_lg ul, .hint_lg ul li {
      color: #65daa2 !important;
    }

    &:hover {
      a::after, label:after, .a::after {
        background: #65daa2 !important;
      }
    }

    .router-link-active::after {
      background: #65daa2 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue